import type { ReactNode } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';

interface Crumb {
  label: string;
  to?: string;
}

interface PageHeaderProps {
  crumbs: Crumb[];
  title: string;
  description?: string;
  icon?: string;
  children?: ReactNode;
}

export default function PageHeader({ crumbs, title, description, icon, children }: PageHeaderProps) {
  return (
    <section className="w-full border-b border-background-200 bg-background-100">
      <div className="container-page py-8 md:py-10">
        <Breadcrumb items={crumbs} />
        <div className="mt-4 flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div className="min-w-0">
            <h1 className="flex items-center gap-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              {icon && (
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className={`${icon} text-xl`}></i>
                </span>
              )}
              {title}
            </h1>
            {description && (
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
                {description}
              </p>
            )}
          </div>
          {children}
        </div>
      </div>
    </section>
  );
}